module.exports = ":host {\n  display: block;\n  margin-bottom: 2em; }\n  :host agm-map {\n    height: 300px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/google-map/google-map.scss
// module id = 1U9N
// module chunks = 12